import Vue from 'vue'
import VueRouter from 'vue-router'
import Stats from '@/views/Stats.vue'
import Auth from '@/views/Auth';
import Home from '@/views/Home.vue'
import Leaderboard from '@/views/Leaderboard.vue'
import Login from '@/views/Login.vue'
import Map from '@/views/Map.vue'
import Users from '@/views/Users.vue'
import Challenge from '@/views/Challenge.vue'
import Challenge2 from '@/views/ChallengeAll.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth
  },
  {
    path: '/challenge',
    name: 'Challenge',
    component: Challenge
  },
  {
    path: '/challenge2',
    name: 'Challenge2',
    component: Challenge2
  },
  {
    path: '/Stats/:id',
    name: 'Stats',
    component: Stats
  },
  {
    path: '/stats',
    name: 'Stats',
    component: Stats
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/leaderboard',
    name: 'Leaderboard',
    component: Leaderboard
  },
  {
    path: '/map',
    name: 'Map',
    component: Map
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    // meta: {
    //   requiresAuth: true
    // }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
//   console.log(`Going from ${from.path} --> ${to.path}`)
//   if (to.meta.requiresAuth) {
//     const loginInfo = localStorage.getItem('password');
//     axios
//       .post(`https://stats-api.grayriver.dk/validate`, { password: loginInfo })
//       .then((response) => {
//         if (response.status == 200) {
//           next()
//         } else {
//           next('/protected')
//         }
//       })
//       .catch(function (error) {
//         console.log(error);
//       });
//   }
//   else {
//     next()
//   }
// })

export default router
